import { uploadsActions, uploadsSelectors } from '@anm/store/modules/uploads';
import { useDispatch, useSelector } from 'react-redux';

import StorageErrorModal, { ActionType } from '@anm/components/StorageErrorModal';

type HookProps = {
  actionType: ActionType;
};

const useStorageErrorModal = ({ actionType }: HookProps) => {
  const dispatch = useDispatch();
  const isStorageFull = useSelector(uploadsSelectors.selectIsStorageFull);
  const cleanState = () => dispatch(uploadsActions.setIsStorageFull(false));

  const renderStorageModal = () =>
    isStorageFull ? <StorageErrorModal actionType={actionType} onClose={cleanState} /> : null;

  return renderStorageModal;
};

export default useStorageErrorModal;
